import React from 'react';
import styled from "styled-components";
import Icon from "../../../../atoms/icon";
import ButtonBase from "../../../../atoms/button.base";
import {getAvatar} from "../../../../../models/user";
import Avatar from "../../../../atoms/avatar";
import PhoneIcon from '@icons/phone.svg';
import {isEmpty} from "../../../../helpers/helpers";

const ShowContactAssignedRealtors = ({city_id, realtors, setPerContact}) => {
    return (
        <SuggestedRealtorsCardWrapper className="w-100 d-flex flex-column align-items-center text-center">
            {realtors.map((realtor, key) => {
                let avatarPath = getAvatar('');
                if (!isEmpty(realtor.avatar)) {
                    avatarPath = getAvatar(realtor.realtor_id);
                }

                return (
                    <SuggestedRealtorsCard key={realtor.id} className="d-flex align-items-center py-16 w-100">
                        <Avatar src={avatarPath} size="56"/>

                        <div className="d-flex align-items-start justify-content-between w-100">
                            <SuggestedRealtorsInfo className="mr-16">
                                <h3 className="h4 d-flex align-items-center">
                                    <span>{realtor.realtor_name}</span>
                                </h3>

                                <div className="text-right h4-normal font-weight-light">
                                    {realtor.agency_name}
                                </div>
                            </SuggestedRealtorsInfo>

                            <ButtonBase variant="outline" size="circle-32" circle onClick={() => setPerContact({show: true, property_id: null, realtor_id: realtor.realtor_id, agency_id: null, city_id: city_id})} className="mr-8">
                                <Icon width={16} height={16}>
                                    <PhoneIcon transform="scale(-2,2)"/>
                                </Icon>
                            </ButtonBase>
                        </div>
                    </SuggestedRealtorsCard>
                )
            })}
        </SuggestedRealtorsCardWrapper>
    );
};

export default ShowContactAssignedRealtors;


const SuggestedRealtorsCard = styled.div`
    border-bottom: 1px solid ${props => props.theme.gray200};
	
	.icons {
		svg {
			transform: rotate(90deg);
		}
	}
	
    &:last-child {
        border-bottom: none;
    }
`;

const SuggestedRealtorsInfo = styled.div`
    * {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

const SuggestedRealtorsCardWrapper = styled.div`
   
     @media (max-width: ${props => props.theme.screenSmMax}) {
        margin-top: 0;
    }
    
    &.archive-property {
        position: relative;
		box-shadow: none;
		min-height: 300px;
        
        .archive-property-contact {
              position: absolute;
              top: 0;
              left: 0;
        }
    }
`;
